import * as React from 'react';
import { ButtonState } from '../../button';
import { UnitViewModel, UnitMediaKey } from './unit.type';

type UseUnitParams = {
  unit: UnitViewModel;
  index: number;
  setUnit: (unit: UnitViewModel, index: number) => void;
  deleteUnit: (unit: UnitViewModel) => void;
  errors?: Record<string, string>;
  unitsLength?: number;
};

export function useUnit({ unit, index, setUnit, deleteUnit, errors, unitsLength }: UseUnitParams) {
  const [toggleContent, setToggleContent] = React.useState<ButtonState>(ButtonState.open);

  React.useEffect(() => {
    if (errors) {
      setToggleContent(ButtonState.open);
      return;
    }
    if ((unitsLength || 0) > 1) setToggleContent(ButtonState.closed);
  }, [errors, unitsLength]);

  const handleToggle = (value?: ButtonState) => {
    if (value === undefined) {
      setToggleContent(toggleContent === ButtonState.open ? ButtonState.closed : ButtonState.open);
    } else {
      setToggleContent(value);
    }
  };

  const handleChangeField = (field: keyof UnitViewModel) => (e: { target: { value: any } }) => {
    const newUnit = { ...unit, [field]: e.target.value } as UnitViewModel;
    setUnit(newUnit, index);
  };

  const handleMediaUpdate = (mediaType: UnitMediaKey, url: string) => {
    const key = `${mediaType.toLowerCase().replace('url', '')}Url` as keyof UnitViewModel;
    const newUnit = { ...unit, [key]: url } as UnitViewModel;
    setUnit(newUnit, index);
  };
  const onDelete = () => deleteUnit(unit);

  return {
    toggleContent,
    handleToggle,
    handleChangeField,
    handleMediaUpdate,
    onDelete,
  };
}


